import { render, staticRenderFns } from "./ModalEditUserRole.vue?vue&type=template&id=13e4e011&scoped=true"
import script from "./ModalEditUserRole.vue?vue&type=script&lang=js"
export * from "./ModalEditUserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e4e011",
  null
  
)

export default component.exports